// Tiny inline SVG icon set. Avoids pulling specific @mui/icons-material
// modules through Vite's CJS interop (which has been flaky on first-load
// for newly-introduced icon imports). Each icon is a plain function
// component returning a 24x24 SVG that picks up `currentColor`.

function Svg({ children, size = 20, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconClose = (p) => (
  <Svg {...p}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></Svg>
);
export const IconChevronDown = (p) => (
  <Svg {...p}><polyline points="6 9 12 15 18 9" /></Svg>
);
export const IconSearch = (p) => (
  <Svg {...p}><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></Svg>
);
export const IconSort = (p) => (
  <Svg {...p}>
    <polyline points="7 4 7 20" /><polyline points="3 8 7 4 11 8" />
    <polyline points="17 20 17 4" /><polyline points="13 16 17 20 21 16" />
  </Svg>
);
export const IconFilter = (p) => (
  <Svg {...p}>
    <line x1="4" y1="6" x2="20" y2="6" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="18" x2="20" y2="18" />
    <circle cx="9" cy="6" r="2" fill="currentColor" />
    <circle cx="15" cy="12" r="2" fill="currentColor" />
    <circle cx="8" cy="18" r="2" fill="currentColor" />
  </Svg>
);
export const IconPlus = (p) => (
  <Svg {...p}><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>
);
export const IconMinus = (p) => (
  <Svg {...p}><line x1="5" y1="12" x2="19" y2="12" /></Svg>
);
export const IconHelp = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="10" />
    <path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 1.7-2.5 2-2.5 4" />
    <line x1="12" y1="17" x2="12" y2="17.01" />
  </Svg>
);
export const IconPlay = (p) => (
  <Svg {...p}><polygon points="6 4 20 12 6 20 6 4" fill="currentColor" stroke="none" /></Svg>
);
export const IconMenu = (p) => (
  <Svg {...p}>
    <line x1="4" y1="7" x2="20" y2="7" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="17" x2="14" y2="17" />
  </Svg>
);
export const IconChevronRight = (p) => (
  <Svg {...p}><polyline points="9 6 15 12 9 18" /></Svg>
);
export const IconChevronLeft = (p) => (
  <Svg {...p}><polyline points="15 6 9 12 15 18" /></Svg>
);
export const IconTrash = (p) => (
  <Svg {...p}>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </Svg>
);
